import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Clock, Home } from 'lucide-react';
import Header from '../components/Header';

const CheckoutPending = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-2xl mx-auto px-4 py-16">
        <Card className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-yellow-100 p-4">
              <Clock size={64} className="text-yellow-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Pagamento Pendente
          </h1>
          
          <p className="text-gray-600 mb-8">
            Seu pedido foi recebido e está aguardando confirmação do pagamento.
          </p>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-gray-800 mb-2">O que acontece agora?</h3>
            <ul className="text-left text-sm text-gray-700 space-y-2">
              <li className="flex items-start">
                <span className="mr-2">⏳</span>
                <span>Se você escolheu PIX, efetue o pagamento usando o código QR ou código de barras.</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">⏳</span>
                <span>Após a confirmação do pagamento, você receberá um email de confirmação.</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">⏳</span>
                <span>O processamento pode levar alguns minutos.</span>
              </li>
            </ul>
          </div>

          <div className="flex gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-[#00A86B] hover:bg-[#008c5a] text-white px-8"
            >
              <Home size={20} className="mr-2" />
              Voltar para Home
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CheckoutPending;
